import React from 'react';

/* Soft Glass page header — matches S04/S05 etc. Big light title, grey subtitle,
   actions on the right. The icon prop is still accepted for backwards compat but
   rendered subtly (no coloured chip anymore). */
export default function PageHeader({ title, subtitle, actions, icon: Icon }) {
    return (
        <div className="mb-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div className="flex items-start gap-3 min-w-0">
                {Icon && (
                    <div className="flex-shrink-0 h-10 w-10 rounded-xl flex items-center justify-center bg-white"
                        style={{ border: '1px solid rgba(17,20,24,.08)' }}>
                        <Icon className="h-5 w-5 text-ink-2" />
                    </div>
                )}
                <div className="min-w-0">
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-ink leading-tight"
                        style={{ letterSpacing: '-0.02em' }}>{title}</h1>
                    {subtitle && <p className="text-sm text-ink-2 mt-1.5 font-normal">{subtitle}</p>}
                </div>
            </div>
            {actions && <div className="flex flex-wrap gap-2 lg:justify-end">{actions}</div>}
        </div>
    );
}
